module.exports = __webpack_public_path__ + "img/workflow_1.fe4292b3.jpg";